import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import BusinessIcon from '@material-ui/icons/Business';
import TransformIcon from '@material-ui/icons/Transform';
import PersonIcon from '@material-ui/icons/Person';
import ScheduleIcon from '@material-ui/icons/Schedule';
import AssessmentIcon from '@material-ui/icons/Assessment';
import { hasPermission } from '../../../utils/authenticated';
import SettingsIcon from '@material-ui/icons/Settings';
import Collapse from '@material-ui/core/Collapse';
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  icon: {},
  nested: {
    paddingLeft: theme.spacing.unit * 4,
  },
});

class MenuBar extends React.Component {
  state = {};

  componentWillMount() {
    const { path } = this.props;
    this.setState({
      adminOpen: path.indexOf('/admin') === 0,
      reportsOpen: path.indexOf('/reports') === 0,
    });
  }

  handleMenuSelect = (evt, menuItem) => {
    console.log('handleMenuSelect', menuItem);
    this.setState({
      selectedMenuItem: menuItem,
    });
  };

  handleShowJobReport = (report) => {
    this.props.findJob({
      report,
      onSelect: (job) => this.props.navigateTo(`/reports/${report}/${job.id}`),
    });
  };

  render = () => {
    const { classes, navigateTo, path } = this.props;

    // console.log('state', this.state);
    // console.log('other', this);

    return (<List
      value={this.state.selectedMenuItem}
      onChange={this.handleMenuSelect}
    >
      <ListItem
        button
        value="customers"
        selected={path === '/customers'}
        onClick={() => navigateTo('/customers', { menus: this.state })}
      >
        <ListItemIcon className={classes.icon}>
          <BusinessIcon/>
        </ListItemIcon>
        <ListItemText primary="Customers"/>
      </ListItem>

      <ListItem
        button
        value="jobs"
        selected={path === '/jobs'}
        onClick={() => navigateTo('/jobs')}
      >
        <ListItemIcon className={classes.icon}>
          <TransformIcon/>
        </ListItemIcon>
        <ListItemText primary="Jobs"/>
      </ListItem>

      <ListItem
        button
        value="employees"
        selected={path === '/employees'}
        onClick={() => navigateTo('/employees')}
      >
        <ListItemIcon className={classes.icon}>
          <PersonIcon/>
        </ListItemIcon>
        <ListItemText primary="Employees"/>
      </ListItem>

      <ListItem
        button
        value="scheduling"
        selected={path === '/scheduling'}
        onClick={() => navigateTo('/scheduling')}
      >
        <ListItemIcon className={classes.icon}>
          <ScheduleIcon/>
        </ListItemIcon>
        <ListItemText primary="Scheduling"/>
      </ListItem>

      <ListItem
        button
        value="reports"
        onClick={() => this.setState({ reportsOpen: !this.state.reportsOpen })}
      >
        <ListItemIcon className={classes.icon}>
          <AssessmentIcon/>
        </ListItemIcon>
        <ListItemText primary="Reports"/>
      </ListItem>

      <Collapse in={this.state.reportsOpen} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <ListItem
            button
            className={classes.nested}
            key="jobreport"
            value="jobreport"
            selected={path.indexOf('/reports/jobreport/') === 0}
            onClick={() => this.handleShowJobReport('jobreport')}
          >
            <ListItemText primary="Job Report"/>
          </ListItem>

          <ListItem
            button
            className={classes.nested}
            key="detaileditembreakdown"
            value="detaileditembreakdown"
            selected={path.indexOf('/reports/detaileditembreakdown/') === 0}
            onClick={() => this.handleShowJobReport('detaileditembreakdown')}
          >
            <ListItemText primary="Item Breakdown"/>
          </ListItem>

          <ListItem
            button
            className={classes.nested}
            key="exceptions"
            value="exceptions"
            selected={path.indexOf('/reports/exceptions') === 0}
            onClick={() => this.handleShowJobReport('exceptions')}
          >
            <ListItemText primary="Exceptions"/>
          </ListItem>
        </List>
      </Collapse>

      {hasPermission('Administrator') ? <ListItem
        button
        value="admin"
        onClick={() => this.setState({ adminOpen: !this.state.adminOpen })}
      >
        <ListItemIcon className={classes.icon}>
          <SettingsIcon/>
        </ListItemIcon>
        <ListItemText primary="Admin"/>
      </ListItem> : null}

      <Collapse in={this.state.adminOpen} timeout="auto" unmountOnExit>
        <ListItem
          button
          className={classes.nested}
          key="jobprofiles"
          value="jobprofiles"
          selected={path === '/admin/jobprofiles'}
          onClick={() => navigateTo('/admin/jobprofiles')}
        >
          <ListItemText primary="Job Profiles"/>
        </ListItem>

        <ListItem
          button
          className={classes.nested}
          key="taskprofiles"
          value="taskprofiles"
          selected={path === '/admin/taskprofiles'}
          onClick={() => navigateTo('/admin/taskprofiles')}
        >
          <ListItemText primary="Task Profiles"/>
        </ListItem>

        <ListItem
          button
          className={classes.nested}
          key="roles"
          value="roles"
          selected={path === '/admin/roles'}
          onClick={() => navigateTo('/admin/roles')}
        >
          <ListItemText primary="Roles"/>
        </ListItem>

        <ListItem
          button
          className={classes.nested}
          key="printers"
          value="printers"
          selected={path === '/admin/printers'}
          onClick={() => navigateTo('/admin/printers')}
        >
          <ListItemText primary="Printers"/>
        </ListItem>

        <ListItem
          button
          className={classes.nested}
          key="billing"
          value="billing"
          selected={path === '/admin/billing'}
          onClick={() => navigateTo('/admin/billing')}
        >
          <ListItemText primary="Billing"/>
        </ListItem>
      </Collapse>
    </List>);
  };
};

MenuBar.propTypes = {
  navigateTo: PropTypes.func.isRequired,
  findJob: PropTypes.func.isRequired,
};

export default withStyles(styles)(MenuBar);



// WEBPACK FOOTER //
// ./src/components/Dashboard/MenuBar/index.js